import { Box, styled } from '@mui/material';

export const MoreInfoFormContainer = styled(Box)(() => ({
  width: '100%',
  maxWidth: 360,
  alignSelf: 'center',
}));

export const CaymanLogo = styled('img')(() => ({
  display: 'block',
  width: 180,
  maxWidth: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: 24,
}));
